export default {
  data: ()=> ({}),
  methods: {
    
    setValue(val, nameField){
      console.log()
      this.values[nameField] = val
    },
  }
}